/**
 * i18n 国际化配置入口
 *
 * 架构说明：
 * - 语言包位于 ./zh-CN.js 和 ./en.js，按 common（公共）和各页面模块分组
 * - Element UI 组件的语言包与自定义消息合并，切换语言时自动同步
 * - 语言偏好存储于 localStorage，默认跟随浏览器语言
 *
 * 使用方式：
 *   模板中：{{ $t('common.search') }}
 *   脚本中：this.$t('validate.required')
 *   参数化：this.$t('athleteInfo.customUploadFailed', { 0: '1' })
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhCN from './zh-CN'
import en from './en'

Vue.use(VueI18n)

// 中英文切换开关（暂时隐藏切换入口，默认中文；恢复中英文切换改为 true 即可，
// 切换器组件 LangSwitcher 与语言包均保留，后续新改动仍需按 $t() 适配中英文）
export const LANG_SWITCHER_ENABLED = false

// 合并自定义语言包和 Element UI 语言包
const messages = {
  'zh-CN': {
    ...zhCN,
    ...zhLocale,
  },
  'en': {
    ...en,
    ...enLocale,
  },
}

// 语言检测优先级：localStorage > 浏览器语言 > 默认中文（切换关闭时强制中文）
function getDefaultLocale() {
  if (!LANG_SWITCHER_ENABLED) {
    return 'zh-CN'
  }
  const saved = localStorage.getItem('language')
  if (saved) return saved
  const browserLang = (navigator.language || '').toLowerCase()
  if (browserLang.startsWith('en')) return 'en'
  return 'zh-CN'
}

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  messages,
  silentTranslationWarn: true, // 抑制缺失翻译的警告
})

// 绑定 Element UI 语言切换，使 el-date-picker、el-pagination 等组件跟随切换
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
